// ACROM 100000 Whys -- page interactions (presentation) + real cart wiring.
//
// Cart-wiring half follows the proven house pattern (pavoi-lobe-lifters,
// atta-gems, every CC-clone launch): a native <form action="/cart/add">
// submission, never fetch('/cart/add.js') for the add itself -- a fresh
// click and a same-tier repeat click make zero AJAX cart calls; only a
// genuine tier switch makes one /cart/clear.js call (retried on failure)
// before the same form-post add. Shipping-protection (Priority Insured
// Shipping, $4.95) rides along as items[1][...] on the same POST.
//
// Unlike pavoi (3 variants of ONE product), this launch's 3 tiers are 3
// SEPARATE products (Buy 1 / Buy 2 / Buy 3 Books), so both VARIANT_MAP and
// PRODUCT_ID_MAP are keyed per tier.
(function () {
  'use strict';

  var VARIANT_MAP = {
    'tier-1': 54099877331251,
    'tier-2': 54099877364019,
    'tier-3': 54099877396787
  };
  var PRODUCT_ID_MAP = {
    'tier-1': 10466155331891,
    'tier-2': 10466155364659,
    'tier-3': 10466155397427
  };
  var SHIPPING_PROTECTION_VARIANT_ID = 53646568128819;

  // Shared literal key across every ACROM CC-clone page (deliberate --
  // lets this page tell a different product's tracked variant apart from
  // its own, so switching products across pages still clears correctly).
  var CART_TRACK_KEY = 'acromActiveCartVariant';

  function getForm() {
    return document.getElementById('product-form-100000-whys');
  }

  function getCheckedTierRadio() {
    return document.querySelector('.tier-radio:checked');
  }

  function getSelectedVariantId() {
    var radio = getCheckedTierRadio();
    if (!radio) return null;
    return VARIANT_MAP[radio.value] || null;
  }

  function syncHiddenFields() {
    var form = getForm();
    if (!form) return;
    var radio = getCheckedTierRadio();
    if (!radio) return;
    var variantId = VARIANT_MAP[radio.value];
    var productId = PRODUCT_ID_MAP[radio.value];
    var idInput = form.querySelector('input[name="id"]');
    var productIdInput = form.querySelector('input[name="product-id"]');
    if (idInput && variantId) idInput.value = variantId;
    if (productIdInput && productId) productIdInput.value = productId;
  }

  function getTrackedVariant() {
    try { return localStorage.getItem(CART_TRACK_KEY); } catch (e) { return null; }
  }
  function setTrackedVariant(id) {
    try { localStorage.setItem(CART_TRACK_KEY, String(id)); } catch (e) { /* private mode etc. */ }
  }

  function fetchWithRetry(url, options, retries, delayMs) {
    return fetch(url, options).then(function (res) {
      if (!res.ok && (res.status === 429 || res.status >= 500) && retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      return res;
    }, function (err) {
      if (retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, delayMs); })
          .then(function () { return fetchWithRetry(url, options, retries - 1, delayMs * 2); });
      }
      throw err;
    });
  }

  function getAtcButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-atc-button],[data-atc-button-2]'));
  }

  function setAtcLoading(buttons, loading) {
    buttons.forEach(function (btn) {
      btn.style.pointerEvents = loading ? 'none' : '';
      btn.style.opacity = loading ? '0.6' : '';
      if (loading) {
        btn.dataset.originalText = btn.dataset.originalText || btn.textContent;
        btn.textContent = 'Adding...';
      } else if (btn.dataset.originalText) {
        btn.textContent = btn.dataset.originalText;
      }
    });
  }

  // Restore buttons if the page is restored from bfcache (Back from /checkout).
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    setAtcLoading(getAtcButtons(), false);
  });

  function handleAddToCart(e) {
    e.preventDefault();
    var form = getForm();
    if (!form) return;
    var buttons = getAtcButtons();
    var variantId = getSelectedVariantId();
    if (!variantId) {
      alert('Please select an offer above.');
      return;
    }
    syncHiddenFields();

    var tracked = getTrackedVariant();
    if (tracked && Number(tracked) === variantId) {
      // Already in cart this session -- skip straight to checkout, zero cart-endpoint calls.
      window.location.href = '/checkout';
      return;
    }

    if (!tracked) {
      // Nothing added yet this session. Native form-post -- zero AJAX cart calls.
      // return_to already routes to /checkout.
      setTrackedVariant(variantId);
      setAtcLoading(buttons, true);
      form.submit();
      return;
    }

    // Genuine tier switch: clear the previous tier first (one AJAX call,
    // retried on failure), then the native form-post adds the new one.
    setAtcLoading(buttons, true);
    setTrackedVariant(variantId);
    fetchWithRetry('/cart/clear.js', { method: 'POST' }, 2, 1000)
      .then(function () {
        form.submit();
      })
      .catch(function () {
        setAtcLoading(buttons, false);
        alert('Could not update your cart. Please try again.');
      });
  }

  // ---- Accordions (single-open PER GROUP -- this page has two independent
  // [data-faq-list] groups, Product Information and the FAQ; opening an item
  // in one must never close the other group's open item) ----
  function initFaq() {
    document.querySelectorAll('[data-faq-list]').forEach(function (group) {
      group.querySelectorAll('.faq-item').forEach(function (item) {
        var q = item.querySelector('.faq-q');
        var a = item.querySelector('.faq-a');
        if (!q || !a) return;
        q.addEventListener('click', function () {
          var isOpen = item.classList.contains('open');
          group.querySelectorAll('.faq-item.open').forEach(function (open) {
            open.classList.remove('open');
            open.querySelector('.faq-a').style.maxHeight = null;
          });
          if (!isOpen) {
            item.classList.add('open');
            a.style.maxHeight = a.scrollHeight + 'px';
          }
        });
      });
    });
  }

  // ---- Hero carousel: real slider (track translateX, prev/next, dots) ----
  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var dotsWrap = car.querySelector('[data-dots]');
      var idx = 0;
      slides.forEach(function (_, i) {
        var d = document.createElement('span');
        d.className = 'dot' + (i === 0 ? ' active' : '');
        d.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(d);
      });
      function go(i) {
        idx = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
        Array.prototype.slice.call(dotsWrap.children).forEach(function (d, j) {
          d.classList.toggle('active', j === idx);
        });
      }
      var prevBtn = car.querySelector('[data-prev]');
      var nextBtn = car.querySelector('[data-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); });
    });
  }

  // ---- Delivery line: +5 days from today, computed client-side, never hardcoded ----
  function initDeliveryLine() {
    document.querySelectorAll('[data-delivery-line]').forEach(function (el) {
      var d = new Date();
      d.setDate(d.getDate() + 5);
      var opts = { weekday: 'long', month: 'long', day: 'numeric' };
      el.textContent = 'Delivered on ' + d.toLocaleDateString('en-US', opts) + ' with Express Shipping';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncHiddenFields();
    document.querySelectorAll('.tier-radio').forEach(function (radio) {
      radio.addEventListener('change', syncHiddenFields);
    });
    getAtcButtons().forEach(function (btn) {
      btn.addEventListener('click', handleAddToCart);
    });
    initFaq();
    initCarousel();
    initDeliveryLine();
  });
})();
